var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-inner"},[_c('div',{staticClass:"page-content-wrapper"},[_c('layout-header'),_c('layout-body'),_c('layout-footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }